var textfieldAnalytics = {
  value: 'TextField',
  actions: {
    onClick: {
      type: 'TEXTFIELD_CLICK',
      payload: 'Click'
    },
    onChange: {
      type: 'TEXTFIELD_CHANGE',
      payload: 'Change'
    }
  }
};

export default textfieldAnalytics;
